import { render, staticRenderFns } from "./PixelsOverview.vue?vue&type=template&id=5a4bac04"
import script from "./PixelsOverview.vue?vue&type=script&lang=js"
export * from "./PixelsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports